import React, {
    useState, useEffect, useCallback, memo, useRef,
} from "react";
import { useDispatch } from "react-redux";
import {
    IconClock,
    IconPaint,
} from "@searchComponents/icons";
import { getCookie, setCookie } from "../../../../utils/cookies";
import { addToWishListAction } from "../../../wishListPage/store/actions";

const ArtCard = memo(({
                          isFavour, result, index, total,
                      }) => {
    const [show, setShow] = useState(false);
    const popoverRef = useRef(null);
    const dispatch = useDispatch();

    const onHidePopover = useCallback((event) => {
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setShow(false);
    }, []);

    useEffect(() => {
        if (popoverRef.current) {
            popoverRef.current.focus();
        }
    }, [show]);

    const addToFavour = (event) => {
        const card = event.currentTarget.dataset.id;

        let favoursCard = null;
        if (!getCookie("favour")) {
            favoursCard = {};
        } else {
            favoursCard = JSON.parse(getCookie("favour"));
        }

        if (card in favoursCard) {
            const { [card]: removeCard, ...cards } = favoursCard;
            setCookie("favour", JSON.stringify(cards));
            dispatch(addToWishListAction({ [card]: false }));
        } else {
            // eslint-disable-next-line max-len
            setCookie("favour", JSON.stringify({
                ...favoursCard,
                [event.currentTarget.dataset.id]:
                    {
                        status: true,
                        title: result.post_title,
                        link: result.post_link,
                    },
            }));
            dispatch(addToWishListAction({
                [card]: {
                    status: true,
                    title: result.post_title,
                    link: result.post_link,
                },
            }));
        }
    };

    const delay = 75;
    const animationDelay = `${index * delay}ms`;
    const zIndex = `${-(index - total)}`;

    return (
        <li id={`mus-card-${result.ID}`}
            style={{ animationDelay, zIndex }}
        >
            <a className={`mus-card`} rel="noopener" href={result.post_link}>
                <div className={`mus-card__thumb`} >
                    {result?.image && (
                        <figure className={`mus-card__image`} dangerouslySetInnerHTML={{__html: result.image}}/>
                    )}
                </div>
                <div className={"mus-card__header"}>
                    {result?.post_title && (
                        <h5
                            className={"mus-card__header-title"}
                            dangerouslySetInnerHTML={{
                                __html: result.post_title,
                            }}
                        />
                    )}
                </div>
                <div className={"mus-card__body"}>
                    <ul className={"mus-card__list"}>
                        {result.terms?.artist && (
                            <li className={"mus-card__list-item"}>
                                <div className={"mus-card__list-icon"}>
                                    <IconPaint/>
                                </div>
                                <span className={"mus-card__list-text"}>{result.terms.artist.join(", ")}</span>
                            </li>
                        )}
                        {result.fields?.construction_year && (
                            <li className={"mus-card__list-item"}>
                                <div className={"mus-card__list-icon"}>
                                    <IconClock/>
                                </div>
                                <span className={"mus-card__list-text"}>{result.fields.construction_year}</span>
                            </li>
                        )}
                    </ul>
                </div>
            </a>
        </li>
    );
});

export default ArtCard;
